import { FilterExpression } from "./FilterExpression"
import { SortExpression } from "./SortExpression"
import { Result } from "../Utility/Result"
import { asError } from "../../Helpers/Functions/error"

export interface FilterAndSortExpression<M> {
    filter: FilterExpression<M>[]
    sort: SortExpression<M>
}

export function encodeFilterAndSort<M>(
    filterAndSort?: FilterAndSortExpression<M>,
    defaultSort?: SortExpression<M>
): URLSearchParams | undefined {
    let isEmpty = true

    if (filterAndSort === undefined) {
        return undefined
    }

    const search = new URLSearchParams()

    if (filterAndSort.filter.length > 0) {
        isEmpty = false
        search.set("filter", JSON.stringify(filterAndSort.filter))
    }

    if (
        defaultSort === undefined ||
        defaultSort.desc !== filterAndSort.sort.desc ||
        defaultSort.sortBy !== filterAndSort.sort.sortBy
    ) {
        isEmpty = false
        search.set("sort", JSON.stringify(filterAndSort.sort))
    }

    return isEmpty ? undefined : search
}

export function decodeFilterAndSort<M>(
    search: URLSearchParams,
    defaultSort: SortExpression<M>
): Result<FilterAndSortExpression<M>> {
    try {
        const filterParam = search.get("filter")
        const sortParam = search.get("sort")
        const filter: FilterExpression<M>[] =
            filterParam === null ? [] : JSON.parse(filterParam)
        const sort: SortExpression<M> =
            sortParam === null ? defaultSort : JSON.parse(sortParam)

        return Result.ok({ filter, sort })
    } catch (e) {
        return Result.error(asError(e).message)
    }
}
